import { render, staticRenderFns } from "./MenuLinks.vue?vue&type=template&id=32e2307c&scoped=true&"
import script from "./MenuLinks.vue?vue&type=script&lang=js&"
export * from "./MenuLinks.vue?vue&type=script&lang=js&"
import style0 from "./MenuLinks.vue?vue&type=style&index=0&id=32e2307c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2307c",
  null
  
)

export default component.exports